package org.zq.astrock_ai.api.dto

import kotlinx.serialization.Serializable

object PhoneNumbers {
    fun normalize(raw: String): String = raw.filter { it.isDigit() }

    fun isCnMobile(raw: String): Boolean {
        val phone = normalize(raw)
        return phone.length == 11 && phone[0] == '1' && phone[1] in '3'..'9'
    }

    fun mask(raw: String): String {
        val phone = normalize(raw)
        return if (phone.length == 11) {
            phone.take(3) + "****" + phone.takeLast(4)
        } else {
            phone
        }
    }
}

/** 后台角色：普通用户 / 管理员（不可发卡） / 超级管理员（可生成认证码） */
object StaffRoles {
    const val USER = "user"
    const val ADMIN = "admin"
    const val SUPER = "super"

    fun normalize(raw: String?, superAdminFlag: Boolean = false): String {
        val t = raw.orEmpty().trim().lowercase()
        return when {
            t == SUPER || t == "superadmin" || t == "超管" || t == "超级管理员" -> SUPER
            t == ADMIN || t == "管理员" -> ADMIN
            superAdminFlag -> SUPER
            else -> USER
        }
    }

    fun isSuper(role: String?, superAdminFlag: Boolean = false): Boolean =
        normalize(role, superAdminFlag) == SUPER

    fun isStaff(role: String?, superAdminFlag: Boolean = false): Boolean {
        val n = normalize(role, superAdminFlag)
        return n == ADMIN || n == SUPER
    }

    fun label(role: String?): String = when (normalize(role)) {
        SUPER -> "超级管理员"
        ADMIN -> "管理员"
        else -> ""
    }
}

@Serializable
data class SmsSendRequestDto(
    val phone: String = "",
)

@Serializable
data class SmsSendResponseDto(
    val success: Boolean,
    val message: String = "",
    val resendWaitSeconds: Long = 0,
)

@Serializable
data class SmsLoginRequestDto(
    val phone: String = "",
    val code: String = "",
)

@Serializable
data class SmsLoginResponseDto(
    val success: Boolean,
    val message: String = "",
    val token: String = "",
    val phone: String = "",
    val superAdmin: Boolean = false,
    val persisted: Boolean = false,
    val role: String = StaffRoles.USER,
    val trialGranted: Boolean = false,
    val trialExpiresAtMs: Long = 0L,
    val trialExpiresAtLabel: String = "",
)

@Serializable
data class AuthMeResponseDto(
    val ok: Boolean,
    val phone: String = "",
    val superAdmin: Boolean = false,
    val message: String = "",
    val role: String = StaffRoles.USER,
)
